module.exports = __webpack_public_path__ + "media/images/countryrect/catalonia-240b0037f3ac50bda6e4a62a8ff4293f.svg";